import { jsx as o, jsxs as w } from "react/jsx-runtime";
import { useMemo as u } from "react";
function a(e, r) {
  for (const t of r)
    if (t.route.endsWith("/*")) {
      const n = t.route.slice(0, -2);
      if (e === n || e.startsWith(n + "/"))
        return t;
    } else if (t.route === e)
      return t;
}
function h(e) {
  if (e.windowUrlKey && typeof window < "u") {
    const r = window[e.windowUrlKey];
    if (typeof r == "string" && r)
      return r;
  }
  if (e.envUrlKey)
    try {
      const t = (0, eval)(["import", ".meta"].join(""))?.env?.[e.envUrlKey];
      if (typeof t == "string" && t)
        return t;
    } catch {
    }
  return e.baseUrl;
}
function y(e, r) {
  const t = a(e, r.helpLinks);
  if (!t) return;
  let l = `${h(r)}${t.docPath}`;
  return t.anchor && (l += `#${t.anchor}`), l;
}
function b(e) {
  return e.map((r) => r.route);
}
const v = ({ className: e }) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: e,
    width: "20",
    height: "20",
    "aria-hidden": "true",
    children: [
      /* @__PURE__ */ o("circle", { cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ o("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
      /* @__PURE__ */ o("line", { x1: "12", y1: "17", x2: "12.01", y2: "17" })
    ]
  }
), x = ({
  pathname: e,
  config: r,
  className: t,
  ariaLabel: n,
  icon: l,
  tooltip: c,
  showWhenNoMatch: d = !1
}) => {
  const i = u(
    () => a(e, r.helpLinks),
    [e, r.helpLinks]
  ), f = u(
    () => y(e, r),
    [e, r]
  );
  if (!i && !d)
    return null;
  const s = c ?? i?.label ?? "Help", p = n ?? `Open documentation: ${s}`;
  return /* @__PURE__ */ o(
    "a",
    {
      href: f ?? r.baseUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: t,
      "aria-label": p,
      title: s,
      children: l ?? /* @__PURE__ */ o(v, {})
    }
  );
};
export {
  x as DocsLinkButton,
  a as findHelpLink,
  b as getAllMappedRoutes,
  y as getHelpUrl,
  h as resolveBaseUrl
};
//# sourceMappingURL=index.js.map
